import { Button, Container, Input, Image, Box, Text, Spinner, VStack, Link, Flex, Select} from "@chakra-ui/react"
import { useState } from "react"
import { getFaucet } from "../services/axiosService"
import ReCAPTCHA from "react-google-recaptcha";

const Faucet = () => {
  const [address, setAddress] = useState('')
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [token, setToken] = useState("")
  const [targetChainId, setTargetChainId] = useState("280")

  const handleSubmit = async() => {
    setIsLoading(true)
    setShowSuccessMsg(false)
    setErrorMsg('')
    try{
      if(address.length !== 42 || address.slice(0,2) !== '0x'){
        setErrorMsg('Address is in incorrect format')
        return
      }
      const faucetResponse = await getFaucet(address, targetChainId, token)
      if(faucetResponse.op === 'success'){
        setShowSuccessMsg(true)
      } else if(faucetResponse.op === 'fail'){
        setErrorMsg(faucetResponse.data?.response?.data)
      }
    } catch(err){
      console.log('err', err)
    } finally {
      setIsLoading(false)
    }
  }

  return(
    <Container display='flex' flexDir={'column'} alignItems='center'>
      <Image 
        mt={8}
        src= {'/rubiks_cube.png'} 
        width={['120px','180px']} 
        ml='10px' 
        alt='logo'
        />
      <VStack minW={'full'} mt={8} spacing={5}>
        <Input placeholder="Input your address here" fontSize={'14'} onChange={(e) => {setAddress(e.target.value)}}/>
        <ReCAPTCHA 
            sitekey = "6LdJOBYkAAAAAHx8qQ90UuSUhcah08BDF0ltbZ1-" 
            onChange = {(token:any) => {
              setToken(token)
              setShowButton(true)
            }}
          />
        <Flex flexDir="row" width="full" fontSize={'12px'} alignItems='center' gap={2}>
          <Text whiteSpace={'nowrap'}>Select a chain to receive USDC:</Text>
          <Select 
            fontSize="12px" 
            onChange={e => setTargetChainId(e.target.value)}
            >
            <option value={'280'}>zkSync</option>
            <option value={"421613"}>Arbitrum</option>
            <option value={'420'}>Optimism</option>
            <option value={"59140"}>Linea</option>
            <option value={"1442"}>Polygon zkEVM</option>
            <option value={"534353"}>Scroll</option>
            <option value={"84531"}>Base</option>
          </Select>
        </Flex>
        <Button 
          fontSize={'12px'}
          onClick={handleSubmit}
          disabled={!showButton}
          width='100%'
          >
          {isLoading? <Spinner/> : 'Request USDC'} 
        </Button>
      </VStack>
      {showSuccessMsg
        ?
        <Box display='flex' flexDir='column' minW={'full'} border={'1px'} mt={8} rounded={4} borderStyle={'groove'} bg={'teal'} p={10} alignItems='center'> 
          <VStack>
            <Text as='samp' fontSize={'14'} > You are now in the Faucet queue:</Text>
            <Text as='samp' fontSize={'14'} color={'cyan'} backgroundColor={'gray.800'}> {address} </Text>
          </VStack>
          <VStack mt={4}>
            <Text as='samp' fontSize={'14'}> Testnet USDC should arrive within <Text as="span" color={'orange'}>10 minutes. </Text></Text>
            <Text as='samp' fontWeight="extrabold" fontSize={'14'}>Please note that you can only request USDC on 1 chain every 24 hours. </Text>
          </VStack>
          <Text my={4} as='samp' fontSize={'14'}> You may deposit to our USDC vault after claiming USDC from faucet. Happy Trading! </Text>
          <Image 
            src= {'/screenshot.png'} 
            ml='10px' 
            alt='screenshot'
            />
        </Box>
        : <></>
      }
      
      {errorMsg
        ?
        <Box minW={'full'} border={'1px'} mt={8} rounded={4} borderStyle={'groove'} bg={'red.500'} p={3}> 
          <Text as='samp' fontSize={'14'}> {`[Error]`} {errorMsg} </Text>
        </Box>
        : <></>
      }
      <VStack my={4} alignItems='flex-start' display={'flex'} width='100%'>
        <Text fontSize='13' fontWeight='extrabold' color='gray.300' as={'samp'} mt={8}>Testnet USDC Address: </Text>
        <Link fontSize='13' color='gray.300' as={'samp'} mt={2} onClick={() => {window.open("https://scan-v2.zksync.dev/address/0x1a866b77d516645Ccac77E0e38e2C2a137ca7ff2", "_blank")}}>0x1a866b77d516645Ccac77E0e38e2C2a137ca7ff2 (zkSync)</Link>
        <Link fontSize='13' color='gray.300' as={'samp'} onClick={() => {window.open("https://goerli.arbiscan.io/address/0xe44f732337780EB1cEd38Afd641Bdf3056C2Ea2E", "_blank")}}>0xe44f732337780EB1cEd38Afd641Bdf3056C2Ea2E (Arbitrum)</Link>
        <Link fontSize='13' color='gray.300' as={'samp'} onClick={() => {window.open("https://goerli-optimism.etherscan.io/address/0x3714A8C7824B22271550894f7555f0a672f97809", "_blank")}}>0x3714A8C7824B22271550894f7555f0a672f97809 (Optimism)</Link>
        <Link fontSize='13' color='gray.300' as={'samp'} onClick={() => {window.open("https://explorer.goerli.linea.build/address/0xb77c5A8426Ee2af0Ef2A69FE1202DbAfFD0fBddF", "_blank")}}>0xb77c5A8426Ee2af0Ef2A69FE1202DbAfFD0fBddF (Linea)</Link>
        <Link fontSize='13' color='gray.300' as={'samp'} onClick={() => {window.open("https://testnet-zkevm.polygonscan.com/address/0xC65e7B01910D456f594f13fB98eC0DEE2DD6797E", "_blank")}}>0xC65e7B01910D456f594f13fB98eC0DEE2DD6797E (Polygon zkEVM)</Link>
        <Link fontSize='13' color='gray.300' as={'samp'} onClick={() => {window.open("https://blockscout.scroll.io/address/0xEe0Ed0EE9E7a64Dcf3D79B93bD6919843e9747aa", "_blank")}}>0xEe0Ed0EE9E7a64Dcf3D79B93bD6919843e9747aa (Scroll)</Link>
        <Link fontSize='13' color='gray.300' as={'samp'} onClick={() => {window.open("https://goerli.basescan.org/address/0x34910cA595c135822f8DE908e29CD381f3EC9581", "_blank")}}>0x34910cA595c135822f8DE908e29CD381f3EC9581 (Base)</Link>
      </VStack>
    </Container>
  )
}

export default Faucet
